import { render, staticRenderFns } from "./InputFromSchema.vue?vue&type=template&id=6e28af9f&"
import script from "./InputFromSchema.vue?vue&type=script&lang=js&"
export * from "./InputFromSchema.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSwitch,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/builds/saas-tool/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e28af9f')) {
      api.createRecord('6e28af9f', component.options)
    } else {
      api.reload('6e28af9f', component.options)
    }
    module.hot.accept("./InputFromSchema.vue?vue&type=template&id=6e28af9f&", function () {
      api.rerender('6e28af9f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inputs/InputFromSchema.vue"
export default component.exports